<script>
import { Event } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      initialValues: {
        title_pl: 'Wkrótce grane',
        title_en: 'Upcoming events',
        page_size: 6
      }
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Ilość wydarzeń na stronę',
              modelPath: [this, 'form', 'page_size'],
              required: true,
              type: 'number'
            }),
            new fields.Switch({
              label: 'Ręczny wybór wydarzeń',
              modelPath: [this, 'form', 'is_manual']
            }),
            new fields.ForeignKey({
              service: Event,
              label: 'Wydarzenia',
              modelPath: [this, 'form', 'events'],
              multiple: true,
              sortable: true,
              labelField: 'title_pl',
              condition: !!this.form.is_manual
            })
          ]
        }
      ]
    }
  }
}
</script>
